import { render } from "./group-card.vue?vue&type=template&id=5307b31b"
import script from "./group-card.vue?vue&type=script&lang=js"
export * from "./group-card.vue?vue&type=script&lang=js"
script.render = render

export default script